import React from 'react'
import { links, constants } from 'common/helpers'

import NewProductsModal from 'components/modals/newProducts/NewProductsModal/NewProductsModal'

import messages from './messages'

// resolve picture x2
import lipBalmsImage from './images/lipBalms.jpg'


const LipBalmsModal = ({ name, onClose }) => (
  <NewProductsModal
    name={constants.modals.newProducts.LipBalms}
    eventName={constants.analyticsEvents.popupLipBalms}
    link={links.bodyLip}
    buttonMessageTitle={messages.buttonTitle}
    pictureMessageTitle={messages.pictureTitle}
    imgSrc={lipBalmsImage}
    textMessage={messages.text}
    onClose={onClose}
  />
)


export default LipBalmsModal
